import API from "./API";

export default class GarantiasRetencoes extends API
{
    static async all() {
        return this.get("api/admin/garantias-retencoes/list");
    }

    static async search(filter) {
        return this.get("api/admin/garantias-retencoes",{params: filter});
    }

    static async create(fields) {
        return this.post("api/admin/garantias-retencoes", fields);
    }

    static async update(fields, id) {
        return this.put("api/admin/garantias-retencoes/" + id, fields);
    }

    static async deleteTask(id) {
        return this.delete("api/admin/garantias-retencoes/" + id);
    }

    static async getPrints(id) {
        let params = {
            garantias_obras_id: id
        }
        return this.get("api/admin/garantias-retencoes/get-prints", { params: params });
    }

    static async printRetencoes(id) {
        let params = {
            garantias_retencoes_id: id
        }
        return this.post("api/admin/garantias-retencoes/print", params);
    }

    static async find(id) {
        return this.get("api/admin/garantias-retencoes/" + id);
    }
}